

export const defaultAuthenticationValue = {

    isLoggedIn: false,
    setLoginStatus: (token, refreshToken) => {}
}